<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>Employer's PAYE Reference</h1>
    <p>A PAYE reference is a unique identification number assigned to an employer by HMRC.</p>
    <p>Your PAYE reference can be found on any correspondance from HMRC or by logging into your gov.uk gateway account.</p>
    </div>
    <div class="cell small-2">
      <form class="fieldset" @submit.prevent>
        <input 
          type="text" 
          id="taxDistrict" 
          name="taxDistrict" 
          placeholder="" 
          v-model="formData.taxDistrict" 
          required 
          maxlength="3"
          pattern="\d{3}"
          inputmode="numeric"
          @input="formData.taxDistrict = formData.taxDistrict.replace(/[^0-9]/g, '').slice(0, 3)"
        >
      </form>
    </div>
    <span>/</span>
    <div class="cell small-5">
      <form class="fieldset" @submit.prevent>
        <input 
          type="text" 
          id="payeReference" 
          name="payeReference" 
          placeholder="" 
          v-model="formData.payeReference" 
          required 
          maxlength="10"
          pattern="[A-Z0-9]{1,10}"
          @input="formData.payeReference = (formData.payeReference || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 10)"
        >
      </form>
    </div>



</template>


<script setup>

import { ref, onMounted } from 'vue'

const error = ref([]);

const props = defineProps({
  formData: Object
})


const validateStep = () => {

  error.value = [];

  if (!props.formData.taxDistrict || !/^\d{3}$/.test(props.formData.taxDistrict)) {
    error.value.push('Please enter a valid 3-digit Tax District number.');
  }


  if (
    !props.formData.payeReference ||
    !/^[A-Za-z0-9]{1,10}$/.test(props.formData.payeReference)
  ) {
    error.value.push('Please enter a valid PAYE Reference (1-10 letters or numbers).');
  }

  if (error.value.length > 0) return false;


  return true;
}



const executeStep = async () => {
  return true;
}



onMounted(() => {

});

defineExpose({ validateStep, executeStep });

</script>